import { Box, Container, Divider, Grid, Link, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const Consensus = () => {
  return (
    <Container className="container-xxl my-4">
      <Box className="card p-4">
        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Slot:
          </Grid>
          <Grid item xs={9} className="">
            <Link className="d-flex align-items-center gap-2">
              <Typography className="">8219422</Typography>
              <OpenInNewIcon
                fontSize="small"
                className="text-dt text-icon ms-1"
              />
            </Link>
          </Grid>
        </Grid>
        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Epoch:
          </Grid>
          <Grid item xs={9} className="">
            <Link className="d-flex align-items-center gap-2">
              <Typography className="">256856 </Typography>
              <OpenInNewIcon
                fontSize="small"
                className="text-dt text-icon ms-1"
              />
            </Link>
          </Grid>
        </Grid>
        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Proposer Index:
          </Grid>
          <Grid item xs={9} className="">
            <Link className="d-flex align-items-center gap-2">
              <Typography className="">988840 </Typography>
              <OpenInNewIcon
                fontSize="small"
                className="text-dt text-icon ms-1"
              />
            </Link>
          </Grid>
        </Grid>

        <Divider />
        <Grid container className="mb-4 mt-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Slot Root Hash:
          </Grid>
          <Grid item xs={9} className="">
            <Typography className="">
              0x5ca00180a172ea1e69b46a4990496d35ebf55c31c0347f92e72e67ec74bd3381{" "}
            </Typography>
          </Grid>
        </Grid>

        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Beacon Chain Deposit Count:
          </Grid>
          <Grid item xs={9} className="">
            <Typography className="">1172286</Typography>
          </Grid>
        </Grid>

        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Slot Graffiti:
          </Grid>
          <Grid item xs={9} className="">
            <Typography className="">0x (Hex:Null)</Typography>
          </Grid>
        </Grid>

        <Grid container className="mb-4 ">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Block Randomness:
          </Grid>
          <Grid item xs={9} className="">
            <Typography className="">
              0x871f4d3db8028fde5a1456c9efc44cfada019dac76fb165a33fccf30eae8f8c2
            </Typography>
          </Grid>
        </Grid>
        <Grid container className="mb-4 ">
          <Grid item xs={3} className="text-dt d-flex ">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Randao Reveal:
          </Grid>
          <Grid item xs={9} className="">
            <Typography className="">
              0xaa234cba1b35ec0244168321aff4ba43c7ce15a60ed06cee635f966fe2481bf7b24bd5c9bf8ec0cef7e9a206fbc5c0ff0ce56cb80fd112474fc53881cf45bce2955abc60c46c6b89269d1a4b726bb8e1f2189bff5c4a459220408fc8fc22eb88
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Consensus;
